import { useState as a, useEffect as l } from "react";
import { usePathname as m } from "next/navigation";
const f = (s) => {
  const e = m(), { levelOfDetail: n = "FULL" } = s || {}, [c, t] = a({
    isConnectedRelationship: !1,
    connectedRelUsername: "",
    mainUserMhoId: "",
    connectedUserMhoId: "",
    connectedRelId: -1,
    queryParams: { levelOfDetail: n }
  });
  return l(() => {
    if (e != null && e.includes("connected-relationship-profile") && typeof window < "u" && window.sessionStorage.getItem("connectedRelId") && window.sessionStorage.getItem("connectedRelUsername")) {
      const d = Number(window.sessionStorage.getItem("connectedRelId")), o = window.sessionStorage.getItem("connectedRelUsername") || "", [i = "", r = ""] = o.split("__");
      t({
        isConnectedRelationship: !0,
        connectedRelUsername: o,
        mainUserMhoId: i,
        connectedUserMhoId: r,
        connectedRelId: d,
        queryParams: {
          levelOfDetail: n,
          connectedRelUsername: o
        }
      });
    } else
      t({
        isConnectedRelationship: !1,
        connectedRelUsername: "",
        mainUserMhoId: "",
        connectedUserMhoId: "",
        connectedRelId: -1,
        queryParams: { levelOfDetail: n }
      });
  }, [n, e]), c;
};
export {
  f as u
};
